<template>
  <section v-if="$role.restricAccess($route.name, 'view')">
    <breadcrumb-template
      :headtitle="$route.meta.title"
      :breadcrumbcurrent="$route.meta.title"
    ></breadcrumb-template>
    <v-card class="card-outline force-remove-box">
      <v-card-text class="force-custom-bg">
        <v-container fluid>
          <v-row dense class="d-flex justify-end mt-n2">
            <!-- <v-col cols="12" lg="4" class="span-label">
              <span>Player</span>
              <player-autocomplete-template
                ref="player_autocomplete"
              ></player-autocomplete-template>
            </v-col> -->
            <v-col cols="12" lg="2" class="span-label">
              <span>Player</span>
              <v-combobox
                class="regular-field"
                dense
                clearable
                :items="playerlist"
                item-value="id"
                item-text="username"
                label="Player"
                v-model="filter.player_id"
              >
              </v-combobox>
            </v-col>
            <!-- <v-col cols="12" lg="4" class="span-label">
              <span>Player type</span>
              <v-select
                class="regular-field remove-alignment-clear-icon"
                dense
                clearable
                :items="['GM', 'App']"
                label="Player type"
                v-model="filter.playertype"
              ></v-select>
            </v-col> -->
            <v-col cols="12" lg="2" class="span-label">
              <span>Status</span>
              <v-select
                class="regular-field"
                dense
                clearable
                :items="['Active', 'Inactive']"
                label="Status"
                v-model="filter.status"
              ></v-select>
            </v-col>
            <v-col cols="12" lg="4">
              <v-text-field
                clearable
                dense
                class="regular-field"
                v-model="dt_searchQuery"
                label="Search any keyword"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" lg="2" class="mt-7" style="padding-top:5px;">
              <v-btn
                color="green_button"
                class="float-right btn-block"
                @click="getDataFromApi()"
                >Search</v-btn
              >
            </v-col>

            <v-col
              cols="12"
              lg="2"
              class="mt-7"
              style="padding-top:5px;"
              v-if="$role.restricAccess($route.name, 'add') && $store.state.currentUser.agent_data.level > 0"
            >
              <v-btn
                color="green_button"
                class="float-right btn-block"
                @click="modalForm()"
                >Add player</v-btn
              >
            </v-col>

            <v-col cols="12" class="mt-2">
              <v-data-table
                class="custom-header-color table-bordered table-striped"
                :headers="dt_headers"
                :items="dt_resultlist"
                item-key="id"
                :loading="dt_loading"
                :options.sync="dt_options"
                :server-items-length="dt_totalResult"
              >
                <template v-slot:[`item.status`]="{ item }">{{
                  item.status == 1 ? "Active" : "Inactive"
                }}</template>
                <template v-slot:[`item.user_id`]="{ item }">{{
                  item.user_id == null ? "GM" : "App"
                }}</template>

                <template
                  v-slot:[`item.actions`]="{ item }"
                  v-if="$role.restricAccess($route.name, 'edit') && $store.state.currentUser.agent_data.level > 0"
                >
                  <v-btn-toggle block rounded>
                    <v-btn
                      color="green_button"
                      dark
                      small
                      @click="modalForm(item)"
                      ><v-icon>mdi-pencil</v-icon></v-btn
                    >
                    <v-btn
                      color="red_button"
                      dark
                      small
                      @click="deleteData(item.id)"
                      ><v-icon>mdi-delete</v-icon></v-btn
                    >
                  </v-btn-toggle>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>

    <section>
      <v-dialog v-model="dialogForm" width="600px" scrollable persistent>
        <v-card class="card-outline custom-color-dialog">
          <v-card-title class="headline headline_bg">
            <span v-if="modalUpdate">Update player</span>
            <span v-else>Add player</span>
          </v-card-title>

          <v-card-text>
            <v-row no-gutters class="pt-6 m">
              <v-col cols="12" class="form-col span-label">
                <span>Username</span>
                <v-text-field
                  dense
                  class="regular-field"
                  v-model="form.username"
                  label="Username"
                  :error-messages="formerror.username"
                ></v-text-field>
              </v-col>
              <!-- <v-col cols="12" class="form-col span-label">
                <span>Player type</span>
                <v-select
                  dense
                  class="regular-field"
                  :items="checkIsGMCanBet()"
                  v-model="form.player_type"
                  label="Player type"
                  :error-messages="formerror.player_type"
                  @change="setPlayerFields"
                ></v-select>
              </v-col> -->

              <!-- <v-col cols="12" v-if="hasPlayerAccount" class="form-col span-label">
                <span>Password</span>
                <v-text-field dense class="regular-field" v-model="form.password" label="Password" :error-messages="formerror.password"
                ></v-text-field>
              </v-col> -->

              <!-- <v-col cols="12" class="form-col">
                                <agent-autocomplete-template ref="agent_autocomplete"></agent-autocomplete-template>
                            </v-col> -->

              <v-col cols="12" class="form-col span-label">
                <span>Contact number</span>
                <v-text-field
                  dense
                  class="regular-field"
                  v-model="form.contact_no"
                  type="number"
                  label="Contact #"
                  :error-messages="formerror.contact_no"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="form-col">
                <v-switch
                  color="info"
                  dense
                  inset
                  v-model="form.status"
                  label="Status"
                ></v-switch>
              </v-col>
            </v-row>
          </v-card-text>

          <!-- <v-divider></v-divider> -->
          <v-card-actions class="actionButtons pt-6">
            <v-row no-gutters>
              <v-col cols="12">
                <v-btn color="red_button" @click="dialogForm = false"
                  >Back</v-btn
                >
                <span v-if="$role.restricAccess($route.name, 'edit')"
                  ><v-btn
                    color="green_button"
                    class="float-right"
                    @click="updateData"
                    v-if="modalUpdate"
                    :loading="isLoadingBtn"
                    >Update</v-btn
                  ></span
                >
                <v-btn
                  color="green_button"
                  class="float-right"
                  @click="newData"
                  v-if="!modalUpdate"
                  :loading="isLoadingBtn"
                  >Save</v-btn
                >
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </section>

    <confirm-dialog ref="confirm"></confirm-dialog>
  </section>
</template>

<script>
export default {
  data() {
    return {
      dialogForm: false,
      isLoadingBtn: false,
      isLoadingBtnDelete: false,
      formerror: {},
      modalUpdate: false,
      dt_headers: [
        // {
        //   text: (this.$store.state.currentUser.agent_data.level == 1 ? 'Manager/Supervisor' : 'Mananger'),
        //   value: "full_name",
        //   name: "full_name",
        //   sortable: false,
        //   searchable: true,
        // },
        {
          text: "Account #",
          value: "account_no",
          name: "account_no",
          sortable: false,
          searchable: true,
        },
        {
          text: "Player",
          value: "username",
          name: "username",
          sortable: false,
          searchable: true,
        },
        {
          text: "Contact #",
          value: "contact_no",
          name: "p.contact_no",
          sortable: false,
          searchable: true,
        },
        // {
        //   text: "Type",
        //   value: "user_id",
        //   name: "user_id",
        //   sortable: false,
        //   searchable: true,
        // },
        {
          text: "Status",
          value: "status",
          name: "status",
          sortable: false,
          searchable: false,
        },
        // {
        //   text: "Player link",
        //   value: "playerlink",
        //   name: "playerlink",
        //   sortable: false,
        //   searchable: false,
        // },
        {
          text: this.$agentName,
          value: "agentusername",
          name: "agentusername",
          sortable: false,
          searchable: false,
        },
        
        {
          text: "Action",
          value: "actions",
          sortable: false,
          searchable: false,
          width: "10%",
        },
      ],
      dt_options: {},
      dt_columns: {},
      dt_totalResult: 0,
      dt_searchInput: "",
      dt_searchQuery: "",
      dt_resultlist: [],
      dt_loading: true,
      dt_itemsPerPage: 50,
      dt_reload: "",
      form: new this.$Form({
        id: null,
        account_no: null,
        username: "",
        password: "",
        player_type: "GM",
        contact_no: null,
        status: 1,
        agent_id: this.$store.state.currentUser.agent_data.id,
        agent_name: null,
        full_name: null,
        user_id: null,
      }),
      agentID: new this.$Form({
        agent_id:
          this.$store.state.currentUser.agent_data.level != 0
            ? this.$store.state.currentUser.agent_data.id
            : null,
      }),
      filter: {
        playertype: null,
        status: null,
        player_id: null,
      },
      playerlist: [],
      hasPlayerAccount: false,
      // autocomplete_entries: [],
      // autocomplete_isLoading: false,
      // autocomplete_model: [],
      // autocomplete_search: '',
    };
  },
  methods: {
    checkIsGMCanBet(){
      let arr = ['App'];
      if(this.$store.state.currentUser.agent_data.canbet == 1){
          arr.push("GM");
      }else{
        this.form.player_type = "App";
        this.setPlayerFields();
      }
      return arr;
    },
    setManagerSupervisorName() {
      if (this.$store.state.currentUser.agent_data.level == 0) {
        return "Manager";
      } else if (this.$store.state.currentUser.agent_data.level == 1) {
        return "Supervisor";
      } else {
        return "Manager";
      }
    },
    setPlayerFields() {
      if (this.form.player_type == "App") {
        this.hasPlayerAccount = true;
      } else {
        this.hasPlayerAccount = false;
      }
    },
    async modalForm(data) {
      this.form.reset();
      if (data) {
        // console.log(data);
        this.modalUpdate = true;
        this.form.fill(data);
        // this.form.contact_no = data.contact_no;
        if (data.user_id == null) {
          this.hasPlayerAccount = false;
          this.form.player_type = "GM";
        } else {
          this.hasPlayerAccount = true;
          this.form.player_type = "App";
        }

        this.dialogForm = true;
        // await new Promise(resolve => setTimeout(resolve, 300));
        // this.$refs.agent_autocomplete.isupdatesearch(data.full_name);
      } else {
        this.modalUpdate = false;
        this.dialogForm = true;
        // await new Promise(resolve => setTimeout(resolve, 300));
        // this.$refs.agent_autocomplete.autocomplete_model = [];
        // this.$refs.agent_autocomplete.autocomplete_search = '';
      }
    },
    newData() {
      // let agent_autocomplete = this.$refs.agent_autocomplete.autocomplete_model;
      // if(!agent_autocomplete || agent_autocomplete.length <= 0){
      //     this.$refs.agent_autocomplete.errorwatcher('error');
      //     return;
      // }else{
      //     this.$refs.agent_autocomplete.errorwatcher('success');
      // }
      // this.form.agent_id = agent_autocomplete.id;

      this.form
        .post(this.$_CONFIG.api("API_PLAYER"))
        .then(({ data }) => {
          this.isLoadingBtn = false;
          this.getDataFromApi();
          this.dialogForm = false;
          this.$toast.fire({icon: "success", title: "Record has been successfully added",});
        })
        .catch((error) => {
          this.isLoadingBtn = false;
          this.formerror = error.response.data;
          this.$toast.fire({ icon: "error", title: "Something went wrong!" });
        });
    },
    updateData() {
      this.isLoadingBtn = true;
      this.form
        .put(this.$_CONFIG.api("API_PLAYER") + "/" + this.form.id)
        .then(() => {
          this.isLoadingBtn = false;
          this.dialogForm = false;
          this.getDataFromApi();
          // this.$Swal.fire(
          //   "Updated!",
          //   "Record has been successfully updated.",
          //   "green_button"
          // );
          this.$toast.fire({
            icon: "success",
            title: "Record has been successfully updated.",
          });
        })
        .catch((error) => {
          this.isLoadingBtn = false;
          this.formerror = error.response.data;
          this.$toast.fire({ icon: "error", title: "Something went wrong!" });
        });
    },
    async deleteData(id) {
      if (
        await this.$refs.confirm.open(
          "Confirm",
          "Are you sure you want to delete this record?"
        )
      ) {
        this.form
          .delete(this.$_CONFIG.api("API_PLAYER") + "/" + id)
          .then(() => {
            this.dialogForm = false;
            this.getDataFromApi();
            // this.$Swal.fire(
            //   "Deleted!",
            //   "Record has been successfully deleted",
            //   "green_button"
            // );
            this.$toast.fire({
              icon: "success",
              title: "Record has been successfully deleted",
            });
          })
          .catch(() => {
            this.$toast.fire({ icon: "error", title: "Something went wrong!" });
          });
      }
    },
    paramsfilter() {
      let player = null;
      try {
        if (this.filter.player_id) {
          player = this.filter.player_id["id"];
        }
      } catch (error) {
        player = null;
      }
      return {
        ...this.dt_options,
        searchdata: this.dt_searchQuery,
        player_id: player,
        playertype: this.filter.playertype,
        status: this.filter.status,
      };
    },
    async getDataFromApi() {
      this.dt_loading = true;
      var paramsfilter = await this.paramsfilter();
      this.dt_columns = await this.$YajraDT.setHeader(this.dt_headers);
      let params = await this.$YajraDT.params(
        paramsfilter,
        this.dt_options,
        this.dt_itemsPerPage,
        this.dt_columns
      );
      let apiPath = await this.$_CONFIG.api("API_PLAYER");

      await this.$axios
        .get(apiPath + "?" + this.$.param(params))
        .then((res) => {
          if (this.dt_totalResult != res.data.recordsFiltered) {
            this.dt_options.page = 1;
          }

          this.dt_resultlist = res.data.data;
          this.dt_totalResult = res.data.recordsFiltered;
          this.dt_loading = false;
        })
        .catch((err) => {
          this.dt_loading = false;
          console.log("Error searching");
        });

      var unwatch = this.$watch(
        "dt_options.page",
        function(newValue, oldValue) {
          this.getDataFromApi();
          unwatch();
        },
        { deep: true }
      );
    },
    getplayerlist() {
      this.agentID
        .post(this.$_CONFIG.api() + "/v1/playerlist")
        .then((res) => {
          this.playerlist = res.data;
          // console.log(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  created() {
    this.getDataFromApi();
    this.getplayerlist();
  },
  mounted() {},
};
</script>
<style scoped></style>